import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateInvoiceDocument,
  CreateInvoiceMutationVariables,
  DeleteInvoiceEntriesDocument,
  GetInvoicesDocument,
  UpdateInvoiceDocument,
  UpdateInvoiceMutationVariables,
} from "generated/graphql";
import { runGqlMutation, runGqlQuery } from "gqlClient";
import type { Invoice } from "./invoice.slice";

export const fetchInvoices = createAsyncThunk<Invoice[]>(
  "support/invoices",
  async () => await runGqlQuery(GetInvoicesDocument, {}).then((res) => res.client.invoices)
);

export const createInvoice = createAsyncThunk<Invoice, CreateInvoiceMutationVariables>(
  "support/new-invoice",
  async (props) =>
    await runGqlMutation(CreateInvoiceDocument, props).then((res) => ({
      id: res.client.upsertInvoice,
      entryCount: 0,
      ...props,
    }))
);

export const updateInvoice = createAsyncThunk<Omit<Invoice, "entryCount">, UpdateInvoiceMutationVariables>(
  "support/update-invoice",
  async (props) =>
    await runGqlMutation(UpdateInvoiceDocument, props).then(() => ({
      id: props.invoiceId,
      ...props,
    }))
);

export const deleteInvoiceEntries = createAsyncThunk<number, { invoiceId: number }>(
  "support/delete-invoice-entries",
  async (props) =>
    await runGqlMutation(DeleteInvoiceEntriesDocument, props).then((res) => res.client.deleteInvoiceEntries)
);
